import { Outlet, useLocation } from "react-router-dom";
import BannerContent from "../../pages/User/Commitee/CommitteeBannerContent";

function SiteContent() {
  const location = useLocation();
  const pathName = location?.pathname?.split("/");

  return (
    <div >
      {/* {pathName?.includes("Committee") && <BannerContent />} */}
      <Outlet />
    </div>
  );
}

export default SiteContent;
